module.exports = __webpack_public_path__ + "static/media/week-2-tip-2.f128b383.mp3";